// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/components/HomePage.vue';
import BuildingConstruction from '@/views/BuildingConstruction.vue';
import Finance from '@/views/Finance.vue';
import Legal from '@/views/Legal.vue';
import EducationTraining from '@/views/EducationTraining.vue';
import IT from '@/views/IT.vue';
import Travel from '@/views/Travel.vue';
import Migration from '@/views/Migration.vue';
import ConsultingMarketing from '@/views/ConsultingMarketing.vue';
import Advertising from '@/views/Advertising.vue';
import Contact from '@/views/Contact.vue';

const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/building',
    name: 'Building & Construction',
    component: BuildingConstruction,
  },
  {
    path: '/finance',
    name: 'Finance',
    component: Finance,
  },
  {
    path: '/legal',
    name: 'Legal',
    component: Legal,
  },
  {
    path: '/education',
    name: 'Education & Training',
    component: EducationTraining,
  },
  {
    path: '/it',
    name: 'IT',
    component: IT,
  },
  {
    path: '/travel',
    name: 'Travel',
    component: Travel,
  },
  {
    path: '/migration',
    name: 'Migration',
    component: Migration,
  },
  {
    path: '/consulting',
    name: 'Consulting & Marketing',
    component: ConsultingMarketing,
  },
  {
    path: '/advertising',
    name: 'Advertising',
    component: Advertising,
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
